import * as React from 'react';

export interface TabsProps {
    titles: any[];
    bodies: any[];
    selectedIndex?: number;
    setLogo?: boolean;
}


export interface TabsState {
    selectedIndex: number;
}

export default class Tabs extends React.Component<TabsProps, TabsState> {
  constructor(props: TabsProps) {
    super(props);

    this.state = {
        selectedIndex: 0
    }
  }

  public componentDidMount(){
      this.setState({selectedIndex: this.props.selectedIndex || 0})
  }

  public componentWillReceiveProps(nextProps: TabsProps){
      if(nextProps.selectedIndex != this.props.selectedIndex){
          this.setState({selectedIndex: nextProps.selectedIndex || 0})
      }
  }

  changeTabIndex = (index ) => {
      this.setState({selectedIndex: index})
  }

  public render() {
    return (
      <div className='tabs'>
           <div className='tab-header-container'>
                {<h1 className='tab-header show'>{this.props.titles[this.state.selectedIndex]}</h1>}
                {
                    this.props.titles.map((item, index) => {
                        return <h1 key={`tab-header` + index} onClick={() => this.changeTabIndex(index)} className={`tab-header ${this.state.selectedIndex == index? 'active': ''}`}>{item}</h1>
                    })
                }
           </div>
           <div className='tab-content'>
                {
                    this.props.bodies[this.state.selectedIndex]
                }
           </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/tabs.tsx